export default __webpack_public_path__ + "static/media/sweet-3.d345f220.jpg";